import { TagProps } from '@applyboard/crystal-ui';
import { ApplicationType } from '../../data/vasHub/types';

export const VAS_HUB_TRACKING_SOURCE = 'vas_hub';
export const VAS_HUB_STUDENT_LIST_TRACKING_SOURCE = 'vas_hub_studentlist';
export const DEFAULT_AB_WEBSITE = 'https://www.applyboard.com';

type TagIntent = NonNullable<TagProps['intent']>;

export enum ApplicationState {
  INITIATED = 'INITIATED',
  PENDING_CUSTOMER_INPUT = 'PENDING_CUSTOMER_INPUT',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  NOT_STARTED = 'NOT_STARTED',
  UNKNOWN = 'UNKNOWN',
}

export const stateToChipConfig: Record<ApplicationState, { tagColor: TagIntent; label: string }> = {
  [ApplicationState.INITIATED]: { tagColor: 'primary', label: 'Initiated' },
  [ApplicationState.PENDING_CUSTOMER_INPUT]: {
    tagColor: 'warning',
    label: 'Pending customer input',
  },
  [ApplicationState.IN_PROGRESS]: { tagColor: 'primary', label: 'In progress' },
  [ApplicationState.COMPLETED]: { tagColor: 'positive', label: 'Completed' },
  [ApplicationState.REJECTED]: { tagColor: 'negative', label: 'Rejected' },
  [ApplicationState.CANCELLED]: { tagColor: 'negative', label: 'Cancelled' },
  [ApplicationState.NOT_STARTED]: { tagColor: 'secondary', label: 'Not started' },
  [ApplicationState.UNKNOWN]: { tagColor: 'magic', label: 'Internal' },
};

export const STUDENT_LIST_SERVICE_ORDER: ApplicationType[] = ['GIC', 'Loan'];
